import React from "react";
import "./Login.css";
import PropTypes from "prop-types";

export default class Login extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="lmp-login-modal-background"></div>
        <div className="lmp-login-modal" id="modal">
          <span
            class="lnr lnr-cross-circle close"
            onClick={(e) => {
              this.props.onClose && this.props.onClose(e);
            }}
          ></span>
          <div className="content">
            <iframe
              src={this.props.url}
              width="100%"
              height="100%"
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
              }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
Login.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
};
